import Modal from 'components/Modal';
import Table from 'components/Table';
import { UsersResponse } from 'models/response';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import services from 'services';
import actions from 'state/actions';
import selectors from 'state/selectors';
import styled from 'styled-components/macro';
import utils from 'utils';

const MainWrapper = styled.div`
  min-width: 550px;
  > div {
    width: 100%;
  }
  > div {
    > div:nth-child(2) {
      max-height: 410px;
      overflow: auto;
    }
  }
`;

const TableContainer = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: center;
`;

const TableCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Reassign = () => {
  const t = utils.intl.useTranslator();
  const [allowedUsers, setAllowedUsers] = useState<UsersResponse[]>();
  const [user, setUser] = useState<UsersResponse | null>(null);
  const protocols = useSelector(selectors.documents.selectAllActiveDocumentsID);
  const dispatch = useDispatch();
  const userCode = useSelector(selectors.user.getIdUser);
  const idProgram = useSelector(selectors.app.getProgramCode);
  const isAllAuth = useSelector(selectors.documents.selectIsAllAuth);

  const records = useSelector(selectors.documents.selectAllActiveDocuments);
  const companyCode = records[0]?.idCompany || -1;

  const save = async () => {
    if (userCode && user) {
      try {
        await services.reassign({
          idUser: userCode,
          idUserTo: user.idUser,
          idProgram,
          protocols,
        });
        dispatch(actions.modal.closeModal());
        if (isAllAuth) {
          dispatch(actions.documents.updateTableRows({ protocols, property: 'username', value: user.username }));
          dispatch(actions.documents.updateTableRows({ protocols, property: 'userCompleteName', value: user.name }));
        }
      } catch (err) {
        console.error(err);
      }
    }
  };

  useEffect(() => {
    const getAllowed = async () => {
      if (companyCode && userCode) {
        const { data } = await services.getAllowedUsers({
          idUser: userCode,
          idProgram,
          idCompany: companyCode,
        });
        setAllowedUsers(data);
      }
    };
    getAllowed();
  }, [companyCode, idProgram, userCode]);

  return allowedUsers ? (
    <>
      <Modal.Header title={t('assign-document')} subtitle={t('select-user-to-assign-document')} />
      <Modal.Content>
        <MainWrapper>
          <TableContainer>
            <TableCenter>
              <Table
                id="reassign-table"
                columns={[
                  {
                    Header: t('USER'),
                    accessor: 'username',
                    filterType: 'free',
                  },
                  {
                    Header: t('NAME'),
                    accessor: 'name',
                    filterType: 'free',
                  },
                  {
                    Header: t('ROLE'),
                    accessor: 'role',
                    filterType: 'free',
                  },
                ]}
                rows={allowedUsers}
                hasFilter
                hasSort
                hasSelection
                onSelection={(rows: any) => {
                  if (rows[0]) {
                    setUser(rows[0]);
                  }
                }}
                hasPagination
              />
            </TableCenter>
          </TableContainer>
        </MainWrapper>
      </Modal.Content>
      <Modal.Footer confirmText={t('confirm')} confirmAction={save} />
    </>
  ) : null;
};

export default Reassign;
